import Image from 'next/image';
import { Button } from '@jove-frontend/uikit';
import { motion } from 'framer-motion';
import BlueSwoosh from '../../../assets/blue_swoosh.png';
import PurpleSwoosh from '../../../assets/purple_swoosh.png';
import { handleBookDemo } from '../../../util';

export const BespokeInsurance = () => {
  return (
    <div className="bg-dark-blue relative overflow-hidden rounded-2xl p-10 text-white">
      <div className="relative z-10">
        <motion.h2
          className="text-white"
          initial={{ opacity: 0, scale: 0.5 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            transition: { duration: 0.5 },
          }}
          viewport={{ once: true }}
        >
          Bespoke <span className="font-medium">insurance</span> requirements?
        </motion.h2>

        <motion.p
          className="my-6 font-medium sm:w-1/2"
          initial={{ opacity: 0, scale: 0.2 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            transition: { duration: 0.5, delay: 0.3 },
          }}
          viewport={{ once: true }}
        >
          Arrange a call with one of our insurance experts if you have bespoke
          requirements. We will curate the market to deliver the best solution
          that works for you.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            transition: { duration: 0.5, delay: 0.5 },
          }}
          viewport={{ once: true }}
        >
          <Button
            color="secondary-outline-new"
            className="shadow-2xl"
            onClick={handleBookDemo}
          >
            <span className="px-4 font-bold ">Arrange a call</span>
          </Button>
        </motion.div>
      </div>

      <Image
        src={PurpleSwoosh}
        alt="swooshes"
        height={839}
        width={1300}
        className="absolute -bottom-1/3 -right-1/3 z-0 rotate-[174deg] lg:-bottom-full lg:-mb-6 lg:-mr-20"
        style={{ objectFit: 'contain' }}
      />

      <Image
        src={BlueSwoosh}
        alt="swooshes"
        height={839}
        width={1325}
        className="absolute -bottom-1/2 -right-1/4 z-0 rotate-[160deg] lg:top-24 lg:-right-64"
        style={{ objectFit: 'contain' }}
      />
    </div>
  );
};
